export const listAlertFields = {
  computed: {
    listAlertFields() {
      return [
        {
          key: 'alert',
          label: this.$t('cdmSecurityMonitoring.field.notification'),
          tdAttr: {
            style: 'min-width:250px;',
          },
        },
        {
          key: 'vehicle.licensePlate',
          label: this.$t('cdmSecurityMonitoring.field.cdmNumber'),
          isSortable: false,
        },
        {
          key: 'createdOn',
          label: this.$t('global.eventTime'),
          isSortable: false,
          tdAttr: (value, key, item) => ({
            'style': 'width:120px',
            'data-me': `cdm-notif-time-${item.rawAlertId}`,
          }),
        },
        {
          key: 'alertData',
          isSortable: false,
          label: this.$t('global.field.actual'),
          tdAttr: {
            style: 'width:120px',
          },
        },
        {
          key: 'alertTrigger',
          isSortable: false,
          label: this.$t('global.object.limit'),
          tdAttr: {
            style: 'width:120px',
          },
        },
        {
          key: 'address',
          label: this.$t('global.field.address'),
          isSortable: false,
          tdAttr: {
            style: 'min-width:390px;max-width:600px;white-space:normal;',
          },
        },
      ]
    }
  }
}